{
    "Accessibility Menu": "Menu d'accessibilité",
    "Reset settings": "Réinitialiser les paramètres",
    "Close": "Fermer",
    "Content Adjustments": "Ajustements de contenu",
    "Adjust Font Size": "Ajuster la taille de police",
    "Highlight Title": "Surligner le titre",
    "Highlight Links": "Surligner les liens",
    "Readable Font": "Police lisible",
    "Color Adjustments": "Ajustements de couleur",
    "Dark Contrast": "Contraste foncé",
    "Light Contrast": "Contraste clair",
    "High Contrast": "Contraste élevé",
    "High Saturation": "Saturation élevée",
    "Low Saturation": "Saturation faible",
    "Monochrome": "Monochrome",
    "Tools": "Outils",
    "Reading Guide": "Guide de lecture",
    "Stop Animations": "Arrêter les animations",
    "Big Cursor": "Gros curseur",
    "Increase Font Size": "Augmenter la taille de police",
    "Decrease Font Size": "Réduire la taille de police",
    "Letter Spacing": "Espacement des lettres",
    "Line Height": "Hauteur de ligne",
    "Font Weight": "Poids de la police",
    "Dyslexia Font": "Police dyslexie",
    "Language": "Langue",
    "Open Accessibility Menu": "Ouvrir le menu d'accessibilité"
}